import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom/client';
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import axios from 'axios';
import * as XLSX from 'xlsx';
import Header from '../../components/header';
import Sidebar from '../../components/sidebar';
import Loader from '../../components/loader';

import DealerPDFSingle  from "./rateBookTemplate";

function App() {

    
    const userId = sessionStorage.getItem("TRCUserId");
    const [loader, setLoader] = useState(false);
    const [dealerData, setDealerData] = useState(null);
    const [productData, setProductData] = useState(null);
    const [filterData, setFilterData] = useState(null);
    const [zoneData, setZoneData] = useState(null);
    const [routeData, setRouteData] = useState(null);
    const [locationData, setLocationData] = useState(null);
    const [selectedZone, setSelectedZone] = useState(null);
    const [selectedRoute, setSelectedRoute] = useState(null);
    const [selectedLocation, setSelectedZoneLocation] = useState(null);
    const [selectedDealer, setSelectedDealer] = useState(null);


    const getDealers = async () => {
        setLoader(true);
        try {
			const response = await axios.get('https://api.trucoo.in/dealers/rate/',  {
				headers: {
					'Content-Type': 'application/json',
					'X-API-KEY': 'erpTrucoo'
				}
			});
			//console.log(response.data.data);
			if(response.data.status === 'success'){
				setDealerData(response.data.data);
				setProductData(response.data.products);
				setFilterData(response.data.data);
			}
		} catch (error) {
			console.error("Error:", error.response || error.message);
		}
        setLoader(false);
    };

    const getZone = async () => {
        setLoader(true);
        try {
			const response = await axios.get('https://api.trucoo.in/zone/',  {
				headers: {
					'Content-Type': 'application/json',
					'X-API-KEY': 'erpTrucoo'
				}
			});
			if(response.data.status === 'success'){
				setZoneData(response.data.data);
			}
		} catch (error) {
			console.error("Error:", error.response || error.message);
		}
        setLoader(false);
    };

    const getRoute = async () => {
        setLoader(true);
        try {
			const response = await axios.post('https://api.trucoo.in/routes/view/', {}, {
				headers: {
					'Content-Type': 'application/json',
					'X-API-KEY': 'erpTrucoo'
				}
			});
			if(response.data.status === 'success'){
				setRouteData(response.data.routes);
			}
		} catch (error) {
			console.error("Error:", error.response || error.message);
		}
        setLoader(false);
    };
    

    useEffect(() =>{
        getDealers();
        getZone();
        getRoute();
    },[]);

    const getRate = (dealerId, itemId) => {
        const dealer = dealerData?.filter(data => data.id === dealerId)[0]?.rate.filter(item => item.itemId === itemId);
        return dealer[0]?.price || 'NULL';
    };

    const getIncentive = (dealerId, itemId) => {
        const dealer = dealerData?.filter(data => data.id === dealerId)[0]?.rate.filter(item => item.itemId === itemId);
        return dealer[0]?.inc || 'NULL';
    };


    useEffect(() => {
        const locations = selectedRoute ? routeData?.filter(route => route.id === selectedRoute) : null;
        setLocationData(selectedRoute ? locations[0]?.locations : null);
    },[selectedRoute]);

    const changeFilter = () => {

        const data = dealerData?.filter((item) =>
            (!selectedZone || item?.zone === selectedZone) &&
            (!selectedRoute || item?.routeId === selectedRoute) &&
            (!selectedLocation || item?.locationId === selectedLocation) &&
            (!selectedDealer || item?.dealer?.toLowerCase().includes(selectedDealer.toLowerCase()))
        );
        setFilterData(data);
    };

    useEffect(() => {
        changeFilter();
    },[selectedZone, selectedRoute, selectedLocation, selectedDealer]);

    const getTodayDate = () => {
        const today = new Date();
        const day = String(today.getDate()).padStart(2, '0');
        const month = String(today.getMonth() + 1).padStart(2, '0'); // Months are zero-indexed
        const year = today.getFullYear();

        return `${day}-${month}-${year}`;
    };

    const downloadExcel = () => {
        const staticHeaders = ["Dealer", "Zone", "Route", "Location"];

        // First header row
        const headerRow1 = [
            ...staticHeaders,
            ...productData.flatMap(item => [item.productName, null])
        ];

        // Second header row
        const headerRow2 = [
            ...staticHeaders.map(() => null),
            ...productData.flatMap(() => ["Price", "Incentive"])
        ];

        // Data rows
        const data = filterData.map(item => [
            item?.dealer,
            item?.zoneData?.zone,
            item?.route,
            item?.location,
            ...productData.flatMap(product => [
                getRate(item?.id, product?.id),
                getIncentive(item?.id, product?.id)
            ])
        ]);

        const worksheetData = [headerRow1, headerRow2, ...data];

        const ws = XLSX.utils.aoa_to_sheet(worksheetData);

        // Merging cells
        const merges = [];

        // Rowspan for static headers
        staticHeaders.forEach((_, colIndex) => {
            merges.push({
                s: { r: 0, c: colIndex },
                e: { r: 1, c: colIndex }
            });
        });

        // Colspan for product headers
        productData.forEach((_, index) => {
            const colIndex = staticHeaders.length + index * 2;
            merges.push({
                s: { r: 0, c: colIndex },
                e: { r: 0, c: colIndex + 1 }
            });
        });

        ws['!merges'] = merges;

        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Filtered Data');

        XLSX.writeFile(wb, `Rate_Book_${getTodayDate()}.xlsx`);
    };



    const downloadPDF = async (data) => {
        setLoader(true);
        // 1️⃣ Create hidden wrapper
        const wrapper = document.createElement("div");
        wrapper.style.position = "absolute";
        wrapper.style.left = "-9999px";
        wrapper.style.top = "0";
        wrapper.style.background = "white";
        document.body.appendChild(wrapper);

        // 2️⃣ Render component
        const root = ReactDOM.createRoot(wrapper);
        root.render(
            <DealerPDFSingle data={data} products={productData} />
        );

        // 3️⃣ Wait for render
        await new Promise((r) => setTimeout(r, 500));

        // 4️⃣ Capture single page
        const page = wrapper.querySelector(".page");

        const canvas = await html2canvas(page, {
            scale: 2,
            useCORS: true,
            backgroundColor: "#ffffff",
        });

        const imgData = canvas.toDataURL("image/jpeg", 1.0);

        const pdf = new jsPDF("p", "mm", "a4");
        const pdfWidth = pdf.internal.pageSize.getWidth();
        const pdfHeight = (canvas.height * pdfWidth) / canvas.width;

        pdf.addImage(imgData, "JPEG", 0, 0, pdfWidth, pdfHeight);
        pdf.save(`${data?.id}-${data?.dealer}.pdf`);

        // 5️⃣ Cleanup
        root.unmount();
        wrapper.remove();
        setLoader(false);
    };

    

return(
<>
    {loader && <Loader /> }
    <Header />
    <Sidebar />

    <div class="content-wrapper">
        <div class="container-full">
            <section class="content">
            <div class="box">
            <div className="box-header with-border">
            <h4 className="box-title">Rate Book</h4>
            <p className="mb-0 box-subtitle">All Dealers Data</p>

            <div style={{ display: 'flex',  gap: '10px', alignItems: 'center', marginTop: '10px' }}>

                <select className="form-control"  style={{ width: '200px' }} value={selectedZone} onChange={(e)=>setSelectedZone(e.target.value)}>
                    <option value="">All Zone</option>
                    {zoneData?.map((zone, index) => 
                        <option value={zone.id} key={index}>{zone.zone}</option>
                    )}
                </select>

                <select className="form-control"  style={{ width: '200px' }} value={selectedRoute} onChange={(e) => setSelectedRoute(e.target.value)} >
                    <option value="">All Routes</option>
                    {routeData?.map((routes, index) =>
                        <option value={routes.id} key={index}>{routes.route}</option>
                    )}
                </select>

                <select className="form-control"  style={{ width: '200px' }} value={selectedLocation} onChange={(e)=> setSelectedZoneLocation(e.target.value)} >
                    <option value="">All Place</option>
                    {locationData?.map((loc, index) =>
                        <option value={loc.id} key={index}>{loc.location}</option>
                    )}
              
                </select>

                <input type="text" className="form-control" placeholder='Find Dealers...' style={{ width: '200px' }} value={selectedDealer} onChange={(e)=>setSelectedDealer(e.target.value)} />

                <div style={{display: 'flex', justifyContent: 'flex-end', width: '100%'}} >
                    <button onClick={downloadExcel} className="btn btn-sm btn-success ml-2"> Excel <i class="fa fa-download"></i></button>
                </div>
                </div>
            </div>

                <div class="box-body">
                    <div className="table-responsive" style={{width: '100%', height: 'calc(100vh - 300px)', overflow: 'auto', padding: '0 10px 10px 10px'}}>
                      <table style={{whiteSpace: 'nowrap'}} className="table-sm table-bordered nowrap fs-10" id="printableArea" width='100%'>
                        <thead>
                            <tr className="text-dark text-center" style={{ position: 'sticky', top: -1, zIndex: 2, backgroundColor: '#f8f9fa' }}>
                                <th rowSpan={2} style={{whiteSpace: 'nowrap'}}>S.No</th>
                                <th rowSpan={2} style={{whiteSpace: 'nowrap'}}>PARTY</th>
                                <th rowSpan={2} style={{whiteSpace: 'nowrap'}}>ZONE</th>
                                <th rowSpan={2} style={{whiteSpace: 'nowrap'}}>ROUTE</th>
                                <th rowSpan={2} style={{whiteSpace: 'nowrap'}}>PLACE</th>

                                    {productData?.map((item, index) =>
                                        <th colSpan={2} style={{whiteSpace: 'nowrap'}} key={index}>{item?.productName}</th>
                                    )}
                                <th rowSpan={2}>Download</th>
                            </tr>
                            <tr style={{ position: 'sticky', top: '23px', zIndex: 2, backgroundColor: '#f8f9fa' }}>
                                {productData?.map((item, index) => (
                                    <>
                                        <th>Item Price</th>
                                        <th>Incentive</th>
                                    </>
                                ))}
                            </tr>
                        </thead>
                        <tbody>
                            {filterData?.length > 0 ?
                            
                            filterData?.map((data, index)=>
                                <tr>
                                    <td style={{whiteSpace: 'nowrap'}}>{index+1}</td>
                                    <td style={{whiteSpace: 'nowrap'}}>{data?.dealer}</td>
                                    <td style={{whiteSpace: 'nowrap'}}>{data?.zoneData?.zone}</td>
                                    <td style={{whiteSpace: 'nowrap'}}>{data?.route}</td>
                                    <td style={{whiteSpace: 'nowrap'}}>{data?.location}</td>
                                    {productData?.map((item, index) => (
                                        <>
                                            <td style={{whiteSpace: 'nowrap', textAlign: 'center'}} key={index}>{getRate(data?.id, item?.id)}</td>
                                            <td style={{whiteSpace: 'nowrap', textAlign: 'center'}} key={index}>{getIncentive(data?.id, item?.id)}</td>
                                        </>
                                    ))}
                                    <td style={{ position: 'sticky', right: 0, zIndex: 1, backgroundColor: '#f8f9fa', textAlign: 'center' }}>
                                        {/* <DealerPDFSingle data={data} products={productData} /> */}
                                        <button onClick={() => downloadPDF(data)} className="btn btn-sm btn-secondary"><i class="fa fa-download"></i></button>
                                    </td>
                                </tr>
                            )
                            :
                                <tr>
                                    <td class='text-center p-4' colSpan={5}>No Orders</td>
                                </tr>
                            }
                            
                        </tbody>	
                    </table>
                    {/* <Paginator className="custom-paginator" first={first} rows={rows} totalRecords={filterData?.length}  onPageChange={onPageChange} /> */}
                    </div>              
                </div>
              </div>
            </section>
        </div>
    </div>

    {/* <Footer /> */}
</>
);
}

export default App;